export default "__VITE_ASSET__2j06$MYC__"